"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFacets = void 0;
const utils_1 = require("../../utils");
const FACETS_PATH = '/product/facets/';
const getFacets = (_a) => __awaiter(void 0, void 0, void 0, function* () {
    var params = __rest(_a, []);
    const { uf, catalogSlug, businessUnit } = params;
    const url = new URL(`${utils_1.envConfig.apiURL}/${FACETS_PATH}`);
    const urlSearchParams = new URLSearchParams(url.search);
    if (uf) {
        urlSearchParams.append('state', uf);
    }
    if (catalogSlug) {
        urlSearchParams.append('catalog_slug', catalogSlug);
    }
    return utils_1.apiClient.get(`${FACETS_PATH}?${urlSearchParams}`, {
        headers: {
            'x-business-unit': businessUnit,
        },
    });
});
exports.getFacets = getFacets;
